// ordered alphabetically

export const ACCOUNT_CREATION_TYPE = {
  AFTERPAY: 'account_created_for_afterpay',
}

export const CheckoutEvents = {
  EVENTS: {
    ACCOUNT_CREATED: 'Account Created',
    AFTERPAY_POPUP_OPENED: 'Afterpay Popup Opened',
    AFTERPAY_POPUP_REDIRECTED: 'Afterpay Popup Redirected',
    AFTERPAY_SUBSCRIPTION_BUTTON_CLICKED:
      'Afterpay Subscription Button Clicked',
    AFTERPAY_SUBSCRIPTION_BUTTON_RENDERED:
      'Afterpay Subscription Button Rendered',
    AFTERPAY_SUBSCRIPTION_PAYMENT_CANCELLED:
      'Afterpay Subscription Payment Cancelled',
    AUDIO_REFERRAL_SOURCES_COMPLETED: 'Audio Referral Sources Completed',
    CART_EMAIL_CAPTURED_GOLD_STANDARD: 'Cart Email Captured',
    CART_EMAIL_STARTED: 'Cart Email Started',
    CART_EMAIL_VIEWED: 'Viewed Cart Email Step',
    CART_FIELD_CLICKED: 'Cart Field Clicked',
    CART_START: 'Cart Start',
    CHECKOUT_CTA_CLICKED: 'Checkout CTA Clicked',
    CHECKOUT_STEP_COMPLETED: 'Checkout Step Completed',
    EXITED_CART_WITHOUT_PURCHASE: 'Exited cart without purchase',
    PASSWORD_HIDE: 'Password Hide',
    PASSWORD_SHOW: 'Password Show',
    PAYMENT_FAILURE: 'Payment Failure',
    PAYMENT_INFO_STEP_VIEWED_GOLD_STANDARD: 'Payment Info Step Viewed',
    PAYPAL_SUBSCRIPTION_BUTTON_CLICKED: 'PayPal Subscription Button Clicked',
    PAYPAL_SUBSCRIPTION_BUTTON_RENDERED: 'PayPal Subscription Button Rendered',
    PAYPAL_SUBSCRIPTION_OPTION_CLICKED: 'PayPal Subscription Option Clicked',
    PAYPAL_SUBSCRIPTION_PAYMENT_CANCELLED:
      'PayPal Subscription Payment Cancelled',
    PLANS_PAGE_VIEWED_GOLD_STANDARD: 'Plans Page Viewed',
    POSTAL_VERIFICATION: 'Postal Verification',
    PRODUCT_ADDED_GOLD_STANDARD: 'Product Added',
    REFERRAL_SOURCES_COMPLETED: 'Referral Sources Completed',
    SOCIAL_VENDOR_LOG_IN: 'Social Vendor Log In',
    SOCIAL_VENDOR_LOG_IN_INITIATED: 'Social Vendor Log In Initiated',
    STRIPE_RENDERED: 'Stripe Rendered',
    STRIPE_LINK_LOGGED_IN: 'Stripe Link Logged In',
    STRIPE_LINK_LOGGED_OUT: 'Stripe Link Logged Out',
    PAYMENT_INTENT_REQUIRED_ACTION_STARTED:
      'Payment Intent Required Action Started',
    BRAINTREE_CC_RENDERED: 'Braintree CC Rendered',
    APPLE_PAY_RENDERED: 'Apple Pay Rendered',
    GOOGLE_PAY_RENDERED: 'Google Pay Rendered',
    GIFT_PURCHASE_INFO_STEP: 'Gift Purchase Info Step',
    GUEST_PASS_SKIPPED: 'Guest Pass Skipped',
  },
  PAGES: {
    ACCOUNT_CREATION: 'Checkout Step: Account Creation',
    PAYMENT_STEP: {
      CHOOSE_PAYMENT: 'Checkout Step: Choose Payment',
      PAYMENT_ENTRY: 'Checkout Step: Payment Entry',
      IN_CC_INPUT: 'Checkout Step: Credit Card Input',
      IN_PAYPAL_INPUT: 'Checkout Step: PayPal Input',
      IN_APPLE_PAY_INPUT: 'Checkout Step: Apple Pay',
      IN_GOOGLE_PAY_INPUT: 'Checkout Step: Google Pay',
      IN_AFTERPAY_INPUT: 'Checkout Step: Afterpay',
    },
    CART_REGISTRATION: 'Cart Registration',
    REFERRAL: 'Referral Sources',
    AUDIO_REFERRAL: 'Audio Referral Sources',
    GIFT_STEP: 'Checkout Step: Gift Step',
    GUEST_PASS: {
      INPUT: 'Checkout Step: Guest Pass Input',
      SKIP: 'Checkout Step: Guest Pass Skip Screen',
      SUCCESS: 'Checkout Step: Guest Pass Success Screen',
    },
  },
} as const

export const CHECKOUT_TRACK_STEP_NAMES = {
  EMAIL_SUBMISSION: 'email_submission',
  PAYMENT: 'payment',
} as const

export const EMAIL_STARTED_TYPES = {
  EMAIL: 'email',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
} as const

export const FooterEvents = {
  NAV_CLIKED: 'Footer Navigation Clicked',
} as const

export const TRACK_CART_PAYMENT_MODAL_TYPES = {
  CREDIT_CARD: 'credit_card_payment_tab',
  PAYPAL: 'paypal_payment_tab',
  AFTERPAY: 'afterpay_payment_tab',
} as const

export const TRACK_EMAIL_MODAL_TYPE = {
  LOG_IN: 'email_cart_log_in',
  SIGN_UP: 'email_cart_sign_up',
} as const

export const TRACK_PAYMENT_METHODS = {
  CREDIT_CARD: 'Credit_Card',
  PAYPAL: 'PayPal',
  AFTERPAY: 'Afterpay',
  APPLE_PAY: 'Apple Pay',
  GOOGLE_PAY: 'Google Pay',
} as const

export const TRACK_PAYMENT_PROVIDERS = {
  CREDIT_CARD: 'Stripe',
  PAYPAL: 'Braintree',
  AFTERPAY: 'Afterpay',
  APPLE_PAY: 'Apple Pay',
  GOOGLE_PAY: 'Google Pay',
  BRAINTREE: 'Braintree',
} as const

export const TRACK_SIGN_UP_TYPES = {
  SOCIAL: 'Social Sign On Vendor',
  MASTERCLASS: 'MC Login',
} as const
